import { useEffect } from 'react'
import { useGetFleets } from '../api/useGetFleets'
import { useVehicleAllocationStore } from '../store'
import { Allocation, AllocationChange } from '@/types/vehicleAllocation'

export const useValidateFleetNumber = (
    allocation: Allocation,
    allocationChange?: AllocationChange,
    debouncedFleetNumber?: string | null
) => {
    const { data: fleets } = useGetFleets()
    const { runsWithErrors, setRunsErrors, setSwappedBuses, swappedBuses, allocationChanges } =
        useVehicleAllocationStore()

    useEffect(() => {
        if (debouncedFleetNumber) {
            // check if fleet number is valid
            const fleet = fleets?.find((fleet) => fleet.fleetNumber === debouncedFleetNumber)
            if (!fleet) {
                setRunsErrors([...runsWithErrors, allocation.run])
            } else {
                setRunsErrors(runsWithErrors.filter((run) => run !== allocation.run))
            }

            // check if we need to update swapped buses
            if (allocation.bonnet !== allocationChange?.fleetNumber) {
                // check if we have this bonnet assigned to another run
                const isSwapped = allocationChanges.some((change) => change.fleetNumber === allocation.bonnet)
                if (isSwapped) {
                    const filteredSwappedBuses = swappedBuses.filter((bus) => bus !== allocation.bonnet)
                    setSwappedBuses(filteredSwappedBuses)
                } else if (allocation.bonnet) {
                    if (!swappedBuses.includes(allocation.bonnet)) {
                        setSwappedBuses([...swappedBuses, allocation.bonnet])
                    }
                }
            }

            // check if new fleet number is in swapped buses
            if (swappedBuses.includes(debouncedFleetNumber)) {
                const filteredSwappedBuses = swappedBuses.filter((bus) => bus !== debouncedFleetNumber)
                setSwappedBuses(filteredSwappedBuses)
            }
        }
    }, [debouncedFleetNumber])
}
